import openWindow from '@/script/openWindow.mjs'

export default () => {
    const onClick = () => openWindow(
        '/Ai',
        {scene: 'GENERATE_AIS'}
    )

    return {
        title: '影响范围分析任务（迭代版）',
        onClick,
    }
}
